import rma from 'remove-accents';
export default function normalize(s: string) {
  return s != null ? rma(s?.toLowerCase()) : '';
}